/*
Despliega el cuadro con los datos de la organizacion
*/

export interface OrganizationFrameType {
  nin?: string
  phone?: string
  email?: string
  domain?: string
  address?: string
  name?: string
  business?: string
  user?: { name: string; phone: string }
}
export const OrganizationFrame: React.FC<{ organization: OrganizationFrameType }> = ({ organization }) => {
  return (
    <section className="px-4 print:px-0 mb-4 print:mb-2 print:break-inside-avoid text-base print:text-xs">
      <div className="font-bold text-lg print:text-sm text-gray-900">{organization.name}</div>
      <div className="text-gray-700">
        <span className="font-bold">RUT:</span> {organization.nin}
      </div>
      <div className="flex flex-wrap gap-x-8 print:gap-x-4 text-gray-700">
        <span>
          <span className="font-bold">Teléfono:</span> {organization.phone}
        </span>
        <span>
          <span className="font-bold">Email:</span> {organization.email}
        </span>
      </div>
      <div className="flex flex-wrap gap-x-8 print:gap-x-4 text-gray-700">
        <span>
          <span className="font-bold">Web:</span> {organization.domain}
        </span>
        <span>
          <span className="font-bold">Domicilio:</span> {organization.address}
        </span>
      </div>
    </section>
  )
}
